
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import scroll from '@/mixins/scroll';
import { handleFill, imagePreview } from '@/utils/util';
import { getStoreInfo } from '@/api/ccx'
import { setCcxStore } from '@/views/information'

@Component({
  name: 'ApplyCCXStoreDetails'
})
export default class ApplyCCXStoreDetails extends Mixins(scroll) {
  @Getter companyId!: string;

  handleFill = handleFill
  imagePreview = imagePreview

  active = 0;
  tabList = [
    {
      name: '店铺基本信息',
      id: 0,
    },
    {
      name: '收款账户信息',
      id: 1,
    },
    {
      name: '绑定供应商',
      id: 2,
    },
  ];
  detailData: any = {}; // 详情数据

  // 账户类型（回显）
  get banTypeText() {
    const { bankType = 1 } = this.detailData
    return bankType == 1 ? '公司账户' : '私人账户'
  }

  created() {
    // 获取店铺详情数据
    getStoreInfo({ storeId: this.companyId }).then(res => {
      // 缓存常常鲜微店信息
      setCcxStore(res?.data || {})
    })
  }

  onEdit() {
    this.$router.push({
      path: '/editCCXStore'
    })
  }
}
